import { useEffect, useState } from 'react'
import CalendarContent from './Content/CalendarContent'
import { useAuth } from '../../../context/AuthContext'
import { useCalendar } from '../../../context/CalendarContext'

const Calendar = () => {
    const { user } = useAuth()
    const { loadCalendar } = useCalendar()
    const [selectedDate, setSelectedDate] = useState<string | null>(null)

    useEffect(() => {
        if (!user) return
        loadCalendar()
    }, [user])

    return (
        <div className='h-full'>
            <CalendarContent selectedDate={selectedDate} />
        </div>
    )
}

export default Calendar
